import React from "react";
import TitleCell from "./cells/TitleCell";
import OwnersCell from "./cells/OwnersCell";
import TypeCell from "./cells/TypeCell";
const customColumnRenderers = {
  attributes: {
    name: {
      renderCell: (name, collectionEntity) => /* @__PURE__ */ React.createElement(TitleCell, { name, id: collectionEntity.id, type: collectionEntity.type })
    },
    owners: {
      renderCell: (owners) => /* @__PURE__ */ React.createElement(OwnersCell, { owners })
    },
    type: {
      renderCell: (type) => /* @__PURE__ */ React.createElement(TypeCell, { type })
    }
  }
};
export default customColumnRenderers;
